import { useContext } from 'react';

import { ConfigContext } from 'client/common/contexts';

export function useConfig() {
    return useContext(ConfigContext);
}
